module.exports = __webpack_public_path__ + "static/media/22_CALCINHA_TRADICIONAL_FINA_02.98c1d756.jpg";